import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
})
export class AppComponent implements OnInit {
    title = 'CotaGov';

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        // Init Translate
        this.translateService.setDefaultLang('pt');
        this.translateService.use('pt');
    }

}
